// CNPJ é guardado só com dígitos (a máscara é aplicada na tela, nunca digitada pelo usuário) —
// mesmo padrão já usado no bestforce pra resolver usuários digitando com ou sem ponto/traço.
export const onlyDigits = (value) => String(value ?? '').replace(/\D/g, '')

export const normalizeCNPJDigits = (value) => onlyDigits(value).slice(0, 14)

// 00.000.000/0000-00, aplicada progressivamente enquanto o usuário digita
export function maskCNPJ(value) {
    const d = normalizeCNPJDigits(value)
    if (d.length <= 2) return d
    if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`
    if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`
    if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`
}

// exibição em listas/resumos — se o valor salvo não tiver 14 dígitos (registro antigo
// fora do padrão), devolve como está em vez de truncar errado
export const formatCNPJ = (value) => (onlyDigits(value).length === 14 ? maskCNPJ(value) : (value || ''))
